// extracted by mini-css-extract-plugin
export default {"list":"Product_list__Ue45A","amount":"Product_amount__zLd0j","details":"Product_details__X83fW","btn":"Product_btn__qDEc9"};